import {
  Button,
  Card,
  Col,
  Image,
  InputNumber,
  Row,
  Space,
  Tag,
  Typography
} from 'antd'
import React from 'react'
import { Product } from '@a4b/api/src/modules/Monetisation/offerings/types'

const { Title } = Typography

interface Props {
  formItems: Product
  added: (item: Product) => void
}

const OfferingItem: React.FC<Props> = ({ formItems, added }) => (
  <Card
    style={{ width: '100%', marginBottom: 16 }}
    bodyStyle={{ padding: '12px' }}
    bordered
  >
    <Space style={{ marginBottom: 8 }} size={8}>
      <Tag color='blue'>{formItems?.item_type}</Tag>
      <Tag color='blue'>SubType: {formItems?.sub_type}</Tag>
    </Space>
    <Row align="middle" gutter={16}>

      <Col span={3}>
        <Image src={formItems.image_url} />
      </Col>
      <Col span={13}>
        <Space direction="vertical" size={4} style={{ width: '100%', left: 0 }}>

          <Title level={5} style={{ margin: 0 }}>{formItems.title}</Title>
          <Typography.Text type="secondary">{formItems.description}</Typography.Text>
        </Space>
      </Col>
      <Col span={4}>
        <InputNumber value={formItems.price} disabled />
      </Col>
      <Col span={4} style={{ textAlign: 'right' }}>
        <Button
          type='primary'
          onClick={() => {
            added(formItems)
          }}
          size='small'
        >
          Add
        </Button>
      </Col>
    </Row>
  </Card>
)

export default OfferingItem